// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel > small {\n  font-weight: normal;\n  font-style: italic;\n}\n.radio > label > input {\n  opacity: 1 !important;\n  z-index: auto;\n}\n.sv_container .panel-footer {\n  background: none;\n  border-top: none;\n}\n", ""]);
// Exports
module.exports = exports;
